import * as React from "react";
import {Component} from "react";
import {FaIcon} from "../../../../FaIcon";

export class SyncingCell extends Component {
    render() {
        return (
            <td className="double-data" ><FaIcon type="button" iconName="sync-alt" className="syncing-cell" spin={true}/></td>
        );
    }
}
